module.exports = __webpack_public_path__ + "img/btn@2x.6d90f171.png";